import React, {useState, useEffect} from 'react';
import AuthService from "../Services/AuthService";
import Button from '@material-ui/core/Button';
import Dropzone from 'react-dropzone-uploader'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import DoneIcon from '@material-ui/icons/Done';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import ShareIcon from '@material-ui/icons/Share';
import Tooltip from '@material-ui/core/Tooltip';
import {toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {css} from "glamor";
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
//import { Update } from '@material-ui/icons';

const required = (value) => {
    if (!value) {
        return (
            <div className="alert alert-danger" role="alert">
                Este campo es requerido!
            </div>
        );
    }
};

export default function Recursos(props) {

    const [currentUser] = useState(props.user);
    const [files, setFiles] = useState(undefined);
    const [Thumbnail, setThumbnail] = useState(undefined);
    const [openModalFoto, setOpenModalFoto] = useState(false);
    const [OpenModalNewsLetter, setOpenModalNewsLetter] = useState(false);
    const [titulo, setTitulo] = React.useState("");
    const [link, setLink] = React.useState("");
    const [idRcrsDlte, setIdRcrsDlte] = React.useState("");
    const [resources, setResources] = React.useState([]);
    const [openQuestion, setOpenQuestion] = useState(false);
    const [selectedPermission, setSelectedPermission] = React.useState(5);
    const [newsletterLink, setNewsletterLink] = React.useState("");

    useEffect(() => {
        //Consultar todos los recursos
        //consultarRecursos();
        fetchNewsletterLink();
        consultarRecursosSeccion(); 
    }, []);


    const fetchNewsletterLink = () => {
        AuthService.getNewsLetter()
        .then(function(response) {
            if (response.data && response.data.link) {
                setNewsletterLink(response.data.link);
            }
        })
        .catch(function(error) {
            console.log("Error fetching newsletter link:", error);
        });
    };

    const consultarRecursosSeccion = () => {
        let seccion = 3;
        //let permission = 5;
        let rolValue = currentUser.rol[0].value;
        let permission;
        
        switch(rolValue) {
            case 1:
                permission = 5;
                break;
            case 3:
                permission = 4;
                break;
            case 5:
                permission = 3;
                break;
            case 8:
                permission = 2;
                break;
            case 9:
                permission = 1;
                break;
            case 0:
                permission = 1;
                break;
            default:
                permission = 5;
        }
        
        console.log("Consultando recursos de sección: "+seccion+" con permiso: "+permission);   

        AuthService.getSectionResources(seccion, permission)
        .then(function(response) {
            // Use the new resources array from the API response
            setResources(response.data.resources || []);
        })
        .catch(function(error) {
            console.log(error);
        });
    };



    const addRecursos = () => {
        setOpenModalFoto(true);
    }

    const UpdateNewsletter = () => {
        setOpenModalNewsLetter(true);
    }

    const alerts = (msg, error) =>{
            toast(msg, {
                className: css({
                    background: error ? "#E6332A":"#00AC46",
                    color: "white"
                }),
                progressClassName: css({
                    background: error ? "#00AC46":"#FFF"
                })
            });
        };

    const guardarFoto = () => {
        let continua = true;
        let msj = "";
        if (titulo.length === 0) {
            continua = false;
            msj = "Debes agregar un título a tu recurso."
        }
        if (!files) {
            continua = false;
            msj = "Debes agregar un archivo válido para tu recurso."
        }
        if (!Thumbnail) {
            continua = false;
            msj = "Debes agregar una miniatura para tu recurso."
        }
        if (continua) {
            const formData = new FormData();
            formData.append('file', files);
            formData.append('thumbnail', Thumbnail);
            formData.append('title', titulo);
            formData.append('description', 'No Description for Recursos');
            formData.append('video', 'No Video for Recursos');
            formData.append('nombrearchivo', files.name);
            formData.append('section', 3);
            formData.append('permissions', selectedPermission);
            formData.append('uploaderidu', currentUser.idu);
            formData.append('uploadermail', currentUser.correo);

            AuthService.uploadMTfile(formData)
                .then(function(response) {
                    setOpenModalFoto(false);
                    consultarRecursosSeccion();
                    window.location.reload();
                })
                .catch(function(error) {
                    console.log(error);
                });
        } else {
            alerts(msj, true)
        }
    }

    const guardarLink = () => {
        let continua = true;
        let msj = "";
        if (link.length === 0) {
            continua = false;
            msj = "debes agregar un link para actualizar."
        }
        
        if (continua) {
            const formData = new FormData();
            formData.append('link', link);
            formData.append('uploaderidu', currentUser.idu);
            formData.append('uploadermail', currentUser.correo);

            AuthService.updateNewsLetter(formData)
                .then(function(response) {
                    alerts("Newsletter actualizado", false);
                    setOpenModalNewsLetter(false);
                    consultarRecursosSeccion();
                    setTimeout(() => {
                        window.location.reload();
                    }, 5000);
                })
                .catch(function(error) {
                    console.log(error);
                    const errorMessage = (error.response && error.response.data && error.response.data.message) || error.message || "Error al actualizar el newsletter";
                    alerts(errorMessage, true);
                });
        } else {
            alerts(msj, true)
        }
    }

    // called every time a file's `status` changes
    const handleChangeStatusFoto = ({ meta, file }, status) => {
        console.log('GIANADEV: meta is: '+meta)
        if(status==="done"){
            if(meta.type==="application/pdf"){
                setFiles(file)
                console.log("pdf")
            } else {
                /*
                if(meta.height===500){
                    if(meta.width===500){
                    */
                setFiles(file)
                /*
                    } else{
                        alerts("El ancho de la imágen debe ser de 500px.", true)
                    }
                } else {
                    alerts("La altura de la imágen debe ser de 500px.", true)
                }
                */
            }
        }
    }

    const handleChangeThumbnail = ({ meta, file }, status) => {
        console.log('GIANADEV: meta is: '+meta)
        if(status==="done"){
            setThumbnail(file);
        }
    }

    const handleCloseModalFoto = (ev) =>{
        setOpenModalFoto(false);
    };

    const handleCloseModalNewsLetter = (ev) =>{
        setOpenModalNewsLetter(false);
    };

    const onChangeTitulo = (ev) =>{
        console.log("Cambiar titulo: " + ev.target.value)
        setTitulo( ev.target.value );
    };

    const onChangeLink = (ev) =>{
        console.log("Cambiar link: " + ev.target.value)
        setLink( ev.target.value );
    };

    const onChangePermission = (ev) =>{
        console.log("Cambiar permiso: " + ev.target.value)
        setSelectedPermission( ev.target.value );
    };

    const eliminarRecurso = (FileKey) => {
        setIdRcrsDlte(FileKey);
        setOpenQuestion(true)
    };

    const aceptoEliminarRecurso = () => {

        AuthService.removeMTfile(idRcrsDlte, currentUser.idu, currentUser.correo)
            .then((response) => {
                console.log("Recurso eliminado de S3, ID: "+idRcrsDlte);
                //consultarRecursos();
                consultarRecursosSeccion();
                setOpenQuestion(false)
            })
            .catch((error) => {
                console.log("Error al eliminar recurso de S3, ID: "+idRcrsDlte);
                //consultarRecursos();
                consultarRecursosSeccion();
                setOpenQuestion(false)
            })  

            /*
        AuthService.consult(`mutation{ removeRecurso(id:"${idRcrsDlte}"){ id resource_route } }`)
            .then((recursos) => {
                AuthService.deleteResource(recursos.data.data.removeRecurso.resource_route)
                    .then((delRecursos) => {
                        //consultarRecursos();
                        setOpenQuestion(false)
                    })
                    .catch(error => {console.log(error)
                        //consultarRecursos();
                        setOpenQuestion(false)
                    })
            })
            .catch(error => {console.log(error)
                //consultarRecursos();
                setOpenQuestion(false)
            })
                */
    }

    //const S3_BUCKET_URL = "https://mithermomixresourcesdev.s3.us-east-2.amazonaws.com/";
    const S3_BUCKET_URL = process.env.REACT_APP_DEVENV === "true"
    ? (process.env.REACT_APP_STAGEENV === "true"
        ? "https://mithermomixresourcesstage.s3.us-east-2.amazonaws.com/"
        : "https://mithermomixresourcesdev.s3.us-east-2.amazonaws.com/")
    : "https://mithermomixresourcesprod.s3.us-east-2.amazonaws.com/";

    return (
        <div className="row">
            {
                currentUser.rol[0].value===0 &&
                <Button className="greenThermomix" onClick={addRecursos}
                        style={{ width: "230px", color: "white", borderRadius: "10px",
                            fontWeight: "600", padding: "10px", float: "right", marginRight: "50px"
                        }}>
                    <img src="/assets/img/icons/agregar_white_23.png" className="iconAgregarVar" alt="Agregar"/>
                    Agregar recursos
                </Button>
            }

            <div className="col l12" style={{marginTop: "30px"}}>
                {
                    resources.map((resource, i) =>
                        <div className="col l4 gridResourceElement" key={i}>
                            <h5 style={{marginBottom: "15px", color: "#00AC46", textAlign: "center"}}>{resource.PostTitle}</h5>
                            <img
                                width="300px"
                                height="375px"
                                src={S3_BUCKET_URL + resource.FileThumbnail}
                                alt={resource.FileName}
                            />
                            <div className="row" style={{marginTop: "-60px"}}>
                                <div className="col l5">
                                    <Button
                                        onClick={() => window.open(S3_BUCKET_URL + resource.FileKey, "_blank")}
                                        className="greenThermomix"
                                        style={{
                                            padding: "10px", color: "white", borderRadius: "10px", fontWeight: "600"
                                        }}>
                                        <img src="/assets/img/icons/descargar_white_23.png" className="iconDownload" alt="Descargar"/>
                                        Descargar
                                    </Button>
                                </div>
                                <div className="col l2">
                                    {
                                        currentUser.rol[0].value === 0 &&
                                        <Tooltip title="Delete">
                                            <IconButton aria-label="delete" style={{backgroundColor: "#00AC46"}}
                                                        onClick={() => eliminarRecurso(resource.FileKey)}>
                                                <img src="/assets/img/icons/trash_white_23.png" className="iconTrash" alt="Eliminar"/>
                                            </IconButton>
                                        </Tooltip>
                                    }
                                </div>
                                <div className="col l5" style={{display:"none"}}>
                                    <Button className="greenThermomix"
                                        style={{float: "right",
                                            padding: "10px", color: "white", borderRadius: "10px", fontWeight: "600"
                                        }}>
                                        <ShareIcon style={{margin:"0 10"}}/>
                                        Compartir
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>
            <div className="promociones-newsletter-section" style={{marginTop: "30px", clear: "both", float: "none", width: "100%", display: "block"}}>
                <div className="promociones-newsletter-header">
                    <h4 className="promociones-newsletter-title">Newsletter</h4>
                    {
                        currentUser.rol[0].value===0 &&
                        <Button className="greenThermomix promociones-newsletter-button" onClick={UpdateNewsletter}
                                style={{ width: "230px", color: "white", borderRadius: "10px",
                                    fontWeight: "600", padding: "10px"
                                }}>
                            <img src="/assets/img/icons/edit_white_fat_23.png" className="iconAgregarVar" alt="Agregar"/>
                            Actualizar Newsletter
                        </Button>
                    }
                </div>
                <div
                    className="promociones-newsletter-frame"
                    style={{
                        background: "#111",
                        boxSizing: "border-box",
                        overflow: "hidden",
                        position: "relative",
                        width: "100%",
                        height: "clamp(560px, 72vh, 900px)",
                        minHeight: "560px"
                    }}
                >
                    <iframe
                        title="Newsletter"
                        className="promociones-newsletter-iframe"
                        style={{
                            border: "none",
                            display: "block",
                            height: "100%",
                            left: 0,
                            position: "absolute",
                            top: 0,
                            width: "100%"
                        }}
                        src={newsletterLink}
                        seamless="seamless"
                        scrolling="no"
                        frameBorder="0"
                        allowTransparency="true"
                        allowFullScreen="true"
                    ></iframe>
                </div>
            </div>
            <Dialog open={openModalFoto} onClose={handleCloseModalFoto} aria-labelledby="form-dialog-title">
                <DialogTitle className="titleNtfcAddEvent" id="form-dialog-title"
                             onClose={handleCloseModalFoto}  style={{width: "500px"}}>
                    <MuiDialogTitle disableTypography>
                                        <span
                                            className="TitleModalContact">Agregar recurso</span>
                        <IconButton className="closeButtonX" aria-label="close" onClick={handleCloseModalFoto}>
                            <CloseIcon fontSize="large" />
                        </IconButton>
                    </MuiDialogTitle>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>

                    </DialogContentText>

                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="titulo"
                        label="Titulo"
                        name="titulo"
                        autoComplete="titulo"
                        autoFocus
                        value={titulo}
                        onChange={onChangeTitulo}
                        validations={[required]}
                    />

                    <FormControl variant="outlined" fullWidth margin="normal">
                        <InputLabel id="permission-label">Permiso de Acceso</InputLabel>
                        <Select
                            labelId="permission-label"
                            id="permission"
                            value={selectedPermission}
                            onChange={onChangePermission}
                            label="Permiso de Acceso"
                        >
                            <MenuItem value={5}>Presentador</MenuItem>
                            <MenuItem value={4}>Líder</MenuItem>
                            <MenuItem value={3}>GV/SrTL</MenuItem>
                            <MenuItem value={2}>BDM</MenuItem>
                            <MenuItem value={1}>Administrador</MenuItem>
                        </Select>
                    </FormControl>
                
                    <div className="mb-4">
                        <h5 className="text-lg font-semibold mb-2">
                            Subir miniatura
                        </h5>
                    </div>
                    <Dropzone
                        onChangeStatus={handleChangeThumbnail}
                        accept="image/*"
                        maxFiles={1}
                        inputContent="Arrastra una imagen JPG de 300px x 375px (VERTICAL) o haz click aquí para cargarla"
                        inputWithFilesContent={files => `${1 - files.length} more`}
                        submitButtonDisabled={files => files.length < 1}
                    />

                    <div className="mb-4">
                        <h5 className="text-lg font-semibold mb-2">
                            Subir archivo
                        </h5>
                    </div>
                    <Dropzone
                        onChangeStatus={handleChangeStatusFoto}
                        accept="image/*,.pdf"
                        maxFiles={1}
                        inputContent="Arrastra una imagen o un pdf haz click aquí para cargarla"
                        inputWithFilesContent={files => `${1 - files.length} more`}
                        submitButtonDisabled={files => files.length < 1}
                    />

                    {/* <div className="row">
                            <div className="col l12 s12 m12 s12 fieldModal">
                                <FormGroup row>
                                    <FormControlLabel
                                        control={<GreenCheckbox checked={updatePassword} onChange={handleChangeUpdtPass}
                                                                name="updatePassword" />}
                                        label="No volver a mostrar este mensaje." style={{color: "#00AC46"}}
                                    />
                                </FormGroup>
                            </div>
                        </div> */}
                </DialogContent>
                <DialogActions>
                    <Button className="MuiBadge-colorSecondary saveContactBtn"
                            onClick={guardarFoto} color="inherit">
                        <DoneIcon className="iconBtnG" fontSize="small"/>
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openQuestion}
                onClose={()=>setOpenQuestion(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">Eliminar Recurso</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        ¿Estás seguro de eliminar el recurso?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>setOpenQuestion(false)} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={aceptoEliminarRecurso} color="primary" autoFocus>
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={OpenModalNewsLetter} onClose={handleCloseModalNewsLetter} aria-labelledby="form-dialog-title">
                <DialogTitle className="titleNtfcAddEvent" id="form-dialog-title"
                             onClose={handleCloseModalNewsLetter}  style={{width: "500px"}}>
                    <MuiDialogTitle disableTypography>
                                        <span
                                            className="TitleModalContact">Actualizar NewsLetter</span>
                        <IconButton className="closeButtonX" aria-label="close" onClick={handleCloseModalNewsLetter}>
                            <CloseIcon fontSize="large" />
                        </IconButton>
                    </MuiDialogTitle>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>

                    </DialogContentText>
                    <div className="mb-4">
                        <h5 className="text-lg font-semibold mb-2">
                            Ingresar Link
                        </h5>
                    </div>

                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="link"
                        label="link"
                        name="link"
                        autoComplete="link"
                        autoFocus
                        value={link}
                        onChange={onChangeLink}
                        validations={[required]}
                    />
                </DialogContent>
                <DialogActions>
                    <Button className="MuiBadge-colorSecondary saveContactBtn"
                            onClick={guardarLink} color="inherit">
                        <DoneIcon className="iconBtnG" fontSize="small"/>
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>     
    );
}